import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ContactsModel } from 'src/app/models/ContactsModel';
import { ContactsService } from 'src/app/services/ContactsService';

@Component({
  selector: 'app-contacts-search-adv',
  templateUrl: './contacts-search-adv.component.html',
  styleUrls: ['./contacts-search-adv.component.css']
})
export class ContactsSearchAdvComponent implements OnInit {

  concode = '' ;
  conaname = '' ;
  consaklut = '' ;
  conspecial = '' ;
  conclass = '' ;
  conkeyperson = '' ;
  conkeytitel = '' ;
  conarea = 'القاهرة';
  conaddress1 = '' ;
  conaddress2 = '' ;
  contel1 = '' ;
  contel2 = '' ;
  contel3 = '' ;
  conmobile = '' ;
  confax = '' ;
  conemail = '' ;
  conweb = '' ;
  conimage : any ='';
  contype = '' ;
  compcode = '1' ;
  modifaieddate = '2024-01-01' ;
  userid = '' ;
  ContactsList : ContactsModel[]=[];
  Call_Contact ='';
  constructor(public contactsservice : ContactsService,
    public translate: TranslateService,
    public storage: LocalStorageService,
  ) { }

  ngOnInit(): void {
     this.retriveContactsLookupTop();
    //  this.translate.use('ar');
    //  document.documentElement.dir = "rtl";
  }

  retriveContactsLookupTop(){
    this.ContactsList = [];
    this.contactsservice.getAllContactsLookupTop('1','1').subscribe(
      (data: ContactsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ContactsList[i] = data[i];
      }
    })
  }
  retriveContacts(){

    this.ContactsList = [];
    this.contactsservice.getAllContactsLookup(this.concode,this.conaname,this.contype,this.contel1,this.contel2,this.contel3,this.conmobile).subscribe(
      (data: ContactsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ContactsList[i] = data[i];
      }
    })
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }

  OpenDialogCall(pa : ContactsModel){
    this.storage.store('stgPatientCode', pa.concode);
    if(pa.contype == 'مرضى'){ this.Call_Contact = 'Dbank'};
    if(pa.contype == 'أشخاص'){ this.Call_Contact = 'Contacts'};
    if(pa.contype == 'موردين'){ this.Call_Contact = 'Codes'};
    if(pa.contype == 'أطباء'){  this.Call_Contact = 'Doctors';};
  }
}
